export default {
	voteFor: ["#00D57B", "#92e7b4"],
	voteAgainst: ["#DF3848", "#e89aa2"],
	voteAbstain: ["#919191", "#e6e6e6"],
	voteExtraOption: ["#42a5f5", "#42a5f5", "#bbdefb"],
	null: ["#0B7AD5", "#1D529C"],
};
